// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var React = require("react");

var container = Css.style(/* :: */[
      Css.height(Css.px(16)),
      /* :: */[
        Css.marginRight(Css.em(1)),
        /* :: */[
          Css.marginTop(/* zero */-789508312),
          /* :: */[
            Css.width(Css.px(16)),
            /* [] */0
          ]
        ]
      ]
    ]);

var Styles = /* module */[/* container */container];

function Svg(Props) {
  var children = Props.children;
  var title = Props.title;
  return React.createElement("svg", {
              className: container,
              viewBox: "0 0 64 64",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("title", undefined, title), React.createElement("g", undefined, children));
}

var make = Svg;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
